import { View } from 'web-mojo';
import { DeviceList } from '@portal/models/Device.js';

export default class AddMachineDrawer extends View {
    constructor({ locationId }) {
        super();
        this.locationId = locationId;
        this.devices = new DeviceList({ params: { group: app.groupId() } });
    }

    async onInit() {
        await this.devices.fetch();
    }

    onActionScanQr() {
        this.element.querySelector('[name=qr_scan_input]')?.click();
    }

    onActionQrScanned(event, el) {
        // Browser decoding not available — populate field with filename as fallback
        const file = el.files?.[0];
        if (file) {
            app.toast.info('QR scan captured — enter the code manually if not auto-filled');
        }
    }

    async onActionSave() {
        const name = this.element.querySelector('[name=name]').value.trim();
        if (!name) {
            app.toast.warning('Machine name is required');
            return false;
        }

        const manufactureYear = this.element.querySelector('[name=manufacture_year]').value.trim();
        const payload = {
            location: this.locationId,
            name,
            machine_type: this.element.querySelector('[name=machine_type]').value.trim(),
            variant: this.element.querySelector('[name=variant]').value.trim() || null,
            model_number: this.element.querySelector('[name=model_number]').value.trim(),
            serial_number: this.element.querySelector('[name=serial_number]').value.trim(),
            manufacture_year: manufactureYear ? parseInt(manufactureYear) : null,
            qr_code_id: this.element.querySelector('[name=qr_code_id]').value.trim() || null,
            nfc_tag_id: this.element.querySelector('[name=nfc_tag_id]').value.trim() || null,
        };

        const deviceId = this.element.querySelector('[name=device]').value;
        if (deviceId) payload.device = parseInt(deviceId);

        const response = await app.api.post('/api/camaccess/machine', payload);
        if (!response.success || !response.data.status) {
            app.toast.error(response.data?.error || 'Failed to add machine');
            return false;
        }
        app.toast.success('Machine added');
        this.emit('saved', response.data.data);
        return true;
    }

    set template(v) { this._t = v; }

    get template() {
        const deviceOptions = (this.devices.models || []).map(d =>
            `<option value="${d.get('id')}">${d.get('name')} (${d.get('uuid')})</option>`
        ).join('');

        return `
            <div class="p-3">
                <div class="mb-3">
                    <label class="form-label">Machine Name / Number *</label>
                    <input type="text" class="form-control" name="name" placeholder="e.g. VM-042">
                </div>
                <div class="row g-3 mb-3">
                    <div class="col-6">
                        <label class="form-label">Machine Type</label>
                        <input type="text" class="form-control" name="machine_type" placeholder="e.g. compactor">
                    </div>
                    <div class="col-6">
                        <label class="form-label">Variant / Config</label>
                        <input type="text" class="form-control" name="variant" placeholder="e.g. 8-column, chilled">
                    </div>
                </div>
                <div class="row g-3 mb-3">
                    <div class="col-6">
                        <label class="form-label">Model Number</label>
                        <input type="text" class="form-control" name="model_number">
                    </div>
                    <div class="col-6">
                        <label class="form-label">Year of Manufacture</label>
                        <input type="number" class="form-control" name="manufacture_year" placeholder="e.g. 2019" min="1980" max="2099">
                    </div>
                </div>
                <div class="row g-3 mb-3">
                    <div class="col-6">
                        <label class="form-label">Serial Number</label>
                        <input type="text" class="form-control" name="serial_number">
                    </div>
                    <div class="col-6">
                        <label class="form-label">QR Code ID</label>
                        <div class="input-group">
                            <input type="text" class="form-control" name="qr_code_id">
                            <button type="button" class="btn btn-outline-secondary" data-action="scan-qr" title="Scan QR code">
                                <i class="bi bi-qr-code-scan"></i>
                            </button>
                        </div>
                        <input type="file" name="qr_scan_input" accept="image/*" capture="environment"
                            class="d-none" data-action="qr-scanned">
                    </div>
                </div>
                <div class="mb-3">
                    <label class="form-label">NFC Tag ID</label>
                    <input type="text" class="form-control" name="nfc_tag_id">
                </div>
                <div class="mb-4">
                    <label class="form-label">Assign CamLock Device</label>
                    <select class="form-select" name="device">
                        <option value="">No device assigned</option>
                        ${deviceOptions}
                    </select>
                </div>
            </div>
        `;
    }
}
